import axios from 'axios';
import type ProfileType from '../../models/ProfileType';

export default class ProfileTypeHelper {
  static baseUrl = `/api/profileTypes`;

  static getAll = () => axios.get<ProfileType[]>(this.baseUrl);

  static get = (id: number) => axios.get<ProfileType>(`${this.baseUrl}/${id}`);
}
